export default {
  title: "R3mote.io"
};
